// Module
var code = "<div class=\"omc-chart\" ng-class=\"{disabled: $ctrl.disabled}\" ng-attr-id=\"{{$ctrl.id}}\"> <canvas ng-attr-id=\"{{$ctrl.chartId}}\" ng-attr-width=\"{{$ctrl.settings.width}}\" ng-attr-height=\"{{$ctrl.settings.height}}\"></canvas> </div> ";
// Exports
module.exports = code;